module.exports = __webpack_public_path__ + "img/search.ded0f5ea.svg";